import * as Yup from 'yup';

export const getSecretaryResponsibleValidationShape = () => ({
  responsible: Yup.string().when('$requiresManualResponsible', {
    is: true,
    then: (schema) => schema.required('Este campo é obrigatório!'),
    otherwise: (schema) => schema,
  }),
  email: Yup.string()
    .email('Email inválido')
    .when('$requiresManualResponsible', {
      is: true,
      then: (schema) => schema.required('Este campo é obrigatório!'),
      otherwise: (schema) => schema,
    }),
  responsible_phone: Yup.string().when('$requiresManualResponsible', {
    is: true,
    then: (schema) => schema.required('Este campo é obrigatório!'),
    otherwise: (schema) => schema,
  }),
  function: Yup.string().when('$requiresManualResponsible', {
    is: true,
    then: (schema) => schema.required('Este campo é obrigatório!'),
    otherwise: (schema) => schema,
  }),
  responsible_user_id: Yup.mixed().when('$requiresExistingResponsible', {
    is: true,
    then: (schema) => schema.required('Selecione um responsável existente!'),
    otherwise: (schema) => schema.nullable(),
  }),
});
